export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CONNECTED = 'CONNECTED';
export const DEFINE_USER = 'DEFINE_USER';
export const DEFINE_USER_DATA = 'DEFINE_USER_DATA';
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';